import { Icon } from '../types/icons';

export const shoeIcons: Icon[] = [
  {
    key: 'https://cdn.easysize.me/icons/Shoes%20Angled%201.svg',
    url: 'https://cdn.easysize.me/icons/Shoes%20Angled%201.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Shoes%20Angled%202.svg',
    url: 'https://cdn.easysize.me/icons/Shoes%20Angled%202.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Shoes%20Angled%203.svg',
    url: 'https://cdn.easysize.me/icons/Shoes%20Angled%203.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Shoes%20Angled%204.svg',
    url: 'https://cdn.easysize.me/icons/Shoes%20Angled%204.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Shoes+Outline+%2B+Line.svg',
    url: 'https://cdn.easysize.me/icons/Shoes+Outline+%2B+Line.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Shoes%20Outline%201.svg',
    url: 'https://cdn.easysize.me/icons/Shoes%20Outline%201.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Shoes%20Outline%202.svg',
    url: 'https://cdn.easysize.me/icons/Shoes%20Outline%202.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Shoes%20Outline%203.svg',
    url: 'https://cdn.easysize.me/icons/Shoes%20Outline%203.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Shoes%20Outline%20Heels.svg',
    url: 'https://cdn.easysize.me/icons/Shoes%20Outline%20Heels.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Shoes%20Solid%201.svg',
    url: 'https://cdn.easysize.me/icons/Shoes%20Solid%201.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/sneaker-shoe-icon.svg',
    url: 'https://cdn.easysize.me/icons/sneaker-shoe-icon.svg',
  },
];
